var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 21,
    viewBox: "0 0 20 21",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#8e909e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1.701947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.725 14.3605533c-1.35 1.2375-2.925 1.6875-4.725 1.9125-5.625 0-9-6.74999996-9-6.74999996 1.125-2.025 2.475-3.7125 4.275-4.95",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3125 2.99805334c.45-.1125 1.125-.225 1.6875-.225 5.625 0 9 6.75 9 6.75-.45.89999996-1.125 1.79999996-1.8 2.58749996",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.0125 11.5480533c-.5625.5625-1.48782058.675-2.38782058.5625-.9-.225-1.43717942-.675-1.77467942-1.575-.3375-.89999996.225-2.27781557 1.0125-2.84031557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.494934 0 17.505066 18.298053"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOff.15336c8a24f2852544c861155e866fab.svg";
export { ForwardRef as ReactComponent };